import { Box, VStack, Text, Icon, Input, Image } from "@chakra-ui/react";
import { FaCloudUploadAlt, FaFilePdf } from "react-icons/fa";
import { useState } from "react";
import { useDropzone } from "react-dropzone";
import downLoadSymbole from "../../../assets/waveflowmain/downLoadSymbole.png";
import pdfIcon from "../../../assets/waveflowmain/filesIcon/pdfIcon.png"

const FileUploadComponent = () => {
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const onDrop = (acceptedFiles) => {
    setUploadedFiles([...uploadedFiles, ...acceptedFiles]);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: true,
  });

  return (
    <VStack spacing={4} align="start" p={5} boxSizing={"border-box"}>
      <Text fontSize="lg" fontWeight="bold">
        Data Hub
      </Text>
      <Box
        {...getRootProps()}
        w="full"
        border="2px dashed rgba(190, 72, 167, 1)"
        p={5}
        textAlign="center"
        borderRadius="md"
        cursor="pointer"
      >
        <Input {...getInputProps()} />
        <VStack spacing={2}>
          <Image src={downLoadSymbole} boxSize={10} color="gray.400" />
          <Text
            fontSize="sm"
            color="rgba(108, 108, 108, 1)"
            lineHeight={"15px"}
          >
            + Drag and drop files
            <br />
            or <br />
            click here to upload
          </Text>
          <Text fontSize="xs" color="rgba(108, 108, 108, 1)">
            Files supported: PDF, CSV, DOC, TXT, JSON, JS, PY, IPYNB
          </Text>
        </VStack>
      </Box>

      {uploadedFiles.length > 0 && (
        <Box w="full" >
          <Text fontSize="md" fontWeight="bold" mt={4}>
            Uploaded Files
          </Text>
          {uploadedFiles.map((file, index) => (
            <Box key={index} display="flex" alignItems="center" mt={2}>
              <Image src={pdfIcon} color="red.500" boxSize={5} mr={2} />
              <Text fontSize="sm">{file.name}</Text>
            </Box>
          ))}
        </Box>
      )}
    </VStack>
  );
};

export default FileUploadComponent;
